"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarToggleItem = exports.ToolbarToggleGroup = exports.ToolbarSeparator = exports.ToolbarLink = exports.ToolbarGroup = exports.ToolbarButton = exports.Toolbar = void 0;
var React = _interopRequireWildcard(require("react"));
var ToolbarPrimitive = _interopRequireWildcard(require("@radix-ui/react-toolbar"));
var _cn = require("@udecode/cn");
var _classVarianceAuthority = require("class-variance-authority");
var _icons = require("../icons");
var _separator = require("./separator");
var _tooltip = require("./tooltip");
var _jsxRuntime = require("react/jsx-runtime");
var Toolbar = exports.Toolbar = (0, _cn.withCn)(ToolbarPrimitive.Root, 'relative flex select-none items-center gap-1 bg-background');
var ToolbarToggleGroup = exports.ToolbarToggleGroup = (0, _cn.withCn)(ToolbarPrimitive.ToolbarToggleGroup, 'flex items-center');
var ToolbarLink = exports.ToolbarLink = (0, _cn.withCn)(ToolbarPrimitive.Link, 'font-medium underline underline-offset-4');
var ToolbarSeparator = exports.ToolbarSeparator = (0, _cn.withCn)(ToolbarPrimitive.Separator, 'my-1 w-px shrink-0 bg-border');
var toolbarButtonVariants = (0, _classVarianceAuthority.cva)((0, _cn.cn)('inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', '[&_svg:not([data-icon])]:size-5'), {
  defaultVariants: {
    size: 'sm',
    variant: 'default'
  },
  variants: {
    size: {
      default: 'h-10 px-3',
      lg: 'h-11 px-5',
      sm: 'h-9 px-2'
    },
    variant: {
      default: 'bg-transparent hover:bg-muted hover:text-muted-foreground aria-checked:bg-accent aria-checked:text-accent-foreground',
      outline: 'border border-input bg-transparent hover:bg-accent hover:text-accent-foreground'
    }
  }
});
var ToolbarButton = exports.ToolbarButton = (0, _tooltip.withTooltip)(/*#__PURE__*/
// eslint-disable-next-line react/display-name
React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    isDropdown = _ref.isDropdown,
    pressed = _ref.pressed,
    size = _ref.size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, ["children", "className", "isDropdown", "pressed", "size", "variant"]);
  return typeof pressed === 'boolean' ? /*#__PURE__*/
  // @ts-ignore
  (0, _jsxRuntime.jsx)(ToolbarToggleGroup, {
    disabled: props.disabled,
    type: "single",
    value: "single",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ToolbarToggleItem, _objectSpread({
      className: (0, _cn.cn)(toolbarButtonVariants({
        size: size,
        variant: variant
      }), isDropdown && 'my-1 justify-between pr-1', className),
      ref: ref,
      value: pressed ? 'single' : ''
    }, props, {
      children: isDropdown ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex flex-1",
          children: children
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Icons.arrowDown, {
            className: "ml-0.5 size-4",
            "data-icon": true
          })
        })]
      }) : children
    }))
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ToolbarPrimitive.Button, _objectSpread({
    className: (0, _cn.cn)(toolbarButtonVariants({
      size: size,
      variant: variant
    }), isDropdown && 'pr-1', className),
    ref: ref
  }, props, {
    children: children
  }));
}));
ToolbarButton.displayName = 'ToolbarButton';
var ToolbarToggleItem = exports.ToolbarToggleItem = (0, _cn.withVariants)(ToolbarPrimitive.ToggleItem, toolbarButtonVariants, ['variant', 'size']);
var ToolbarGroup = exports.ToolbarGroup = (0, _cn.withRef)(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    noSeparator = _ref2.noSeparator;
  var childArr = React.Children.map(children, function (c) {
    return c;
  });
  if (!childArr || childArr.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cn.cn)('flex', className),
    ref: ref,
    children: [!noSeparator && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "h-full py-1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, {
        orientation: "vertical"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "mx-1 flex items-center gap-1",
      children: children
    })]
  });
});